export default {
  "/set/safeSet/safeSet": [
    {
      path: "/set/safeSet/result",
      name: "safeSetResult",
      meta: {
        title: "成功",
        hiddenTag: true,
        matchedPath: "/set/safeSet/safeSet",
        visible: "1",
        operate: "0"
      }
    },
    {
      path: "/set/safeSet/changePwStep",
      name: "changePwStep",
      meta: {
        title: "短信验证",
        hiddenTag: true,
        matchedPath: "/set/safeSet/safeSet",
        visible: "1",
        operate: "0"
      }
    },
    {
      path: "/set/safeSet/changePwStep2",
      name: "changePwStep2",
      meta: {
        title: "修改密码",
        hiddenTag: true,
        matchedPath: "/set/safeSet/safeSet",
        visible: "1",
        operate: "0"
      }
    },
    {
      path: "/set/safeSet/changePwStep3",
      name: "changePwStep3",
      meta: {
        title: "确认密码",
        hiddenTag: true,
        matchedPath: "/set/safeSet/safeSet",
        visible: "1",
        operate: "0"
      }
    },
    {
      path: "/set/safeSet/cardCertif",
      name: "cardCertif",
      meta: {
        title: "实名认证",
        hiddenTag: true,
        visible: "1",
        operate: "0"
      }
    }
  ],
  "/set/message/notice": [
    {
      path: "/set/message/index",
      name: "SetMessageIndex",
      meta: {
        title: "消息中心",
        visible: "1",
        hiddenTag: true,
        matchedPath: "/set/message/notice",
        operate: "0"
      }
    }
  ]
};
